export default {"src":"/_next/static/media/logo.406c0940.svg","height":396,"width":396,"blurWidth":0,"blurHeight":0};